import CONFIG from '../plugins/callout/calloutConfig';
import CalloutIcon from '../plugins/callout/CalloutIcon';
import DropDownButton from './DropDownButton';
import ToolbarDivider from './ToolbarDivider';

import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const iconCss = ({ spacing }) => ({
  width: 20,
  height: 20,
  fontSize: 10,
  marginRight: spacing(1),
});

export default function CalloutControls({ nested, onAddAtomicBlock }) {
  if (nested) return null;

  return (
    <>
      <DropDownButton
        icon={
          <>
            <FontAwesomeIcon icon={faExclamationCircle} />
            <FontAwesomeIcon icon={faCaretDown} size="xs" />
          </>
        }
        menu
        tooltip="callouts"
      >
        {Object.entries(CONFIG).map(([k, cfg]) => (
          <MenuItem key={k} onMouseDown={() => onAddAtomicBlock('CALLOUT', { callout_type: k })} value={k}>
            <CalloutIcon css={iconCss} type={k} />
            <div>
              {cfg.title}{' '}
              {!!cfg.contexts && (
                <Typography sx={{ color: 'text.secondary', display: 'block' }} variant="caption">
                  (context aware)
                </Typography>
              )}
            </div>
          </MenuItem>
        ))}
      </DropDownButton>
      <ToolbarDivider />
    </>
  );
}
